// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06878dc9","404":"df86ab69","498":"73e3e410"}[chunkId] + ".chunk.js";
};